import {isAxiosError} from "axios";
import {AXIOS_INSTANCE, getApiErrorMessage} from "@/app2/shared/data/axios-instance";

/** improve-api AuthGuard message when PropelAuth user lacks Training::Admin / Training::Student. */
export const TRAINING_ACCESS_FORBIDDEN_MESSAGE = "User does not have training access";

export const isTrainingAccessForbidden = (error: unknown): boolean => {
	if (!isAxiosError(error) || error.response?.status !== 403) {
		return false;
	}
	return getApiErrorMessage(error, "") === TRAINING_ACCESS_FORBIDDEN_MESSAGE;
};

type TrainingAccessForbiddenListener = () => void;

const listeners = new Set<TrainingAccessForbiddenListener>();
let interceptorInstalled = false;

const installTrainingAccessForbiddenInterceptor = (): void => {
	if (interceptorInstalled) {
		return;
	}
	interceptorInstalled = true;
	AXIOS_INSTANCE.interceptors.response.use(
		(response) => response,
		(error: unknown) => {
			if (isTrainingAccessForbidden(error)) {
				listeners.forEach((listener) => listener());
			}
			return Promise.reject(error);
		}
	);
};

/** Subscribe to improve-api 403 training-access denials (interceptor registered once per app lifetime). */
export const subscribeTrainingAccessForbidden = (
	listener: TrainingAccessForbiddenListener
): (() => void) => {
	installTrainingAccessForbiddenInterceptor();
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};
